import { Button } from '@bp/ui-components';
import { AboutBP } from 'components/AboutBP/AboutBP';
import { BpCard } from 'components/BpCard/BpCard';
import { BpPage } from 'components/BpPage/BpPage';
import { useTranslation } from 'react-i18next';

export const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <BpPage title={t('app.title.full')} isForbidden={false} noHeadlineMargin hideBreadcrumbs>
      <BpCard>
        <AboutBP isAdmin={false} matrixOnline={true} />
      </BpCard>
      <BpCard hideBackground>
        <Button>{t('common.back')}</Button>
      </BpCard>
    </BpPage>
  );
};
